/**
 * Stub auth: in-memory user. signInGoogle/signInGithub set a mock user; signOut clears.
 * Replace with Firebase Auth when config has firebaseConfig.
 */

import type { LecturaUser } from '../core/types';

let currentUser: LecturaUser | null = null;
const listeners = new Set<() => void>();

export function getCurrentUser(): LecturaUser | null {
  return currentUser;
}

export function signInGoogle(): Promise<void> {
  currentUser = { uid: 'stub-google-' + Date.now(), email: 'user@example.com', isAnonymous: false };
  listeners.forEach((cb) => cb());
  return Promise.resolve();
}

export function signInGithub(): Promise<void> {
  currentUser = { uid: 'stub-github-' + Date.now(), email: 'user@github.com', isAnonymous: false };
  listeners.forEach((cb) => cb());
  return Promise.resolve();
}

export function signOut(): void {
  currentUser = null;
  listeners.forEach((cb) => cb());
}

export function deleteCurrentUser(): Promise<void> {
  currentUser = null;
  listeners.forEach((cb) => cb());
  return Promise.resolve();
}

export function subscribeUserChange(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
